import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { NativeService } from "../providers/NativeService";
import { Utils } from '../providers/Utils';
import { HttpService } from '../providers/HttpService'
@Component({
  selector: 'app-mall-orders',
  templateUrl: './mall-orders.component.html',
  styleUrls: ['./mall-orders.component.css']
})
export class MallOrdersComponent implements OnInit {
  public tabArr = [
    { 'name': "全部", 'tabId': 0, 'isNoMore': false, 'isFooter': false, 'isError': false, 'isNoData': false, 'page': 1, 'total': 0, 'first': true },
    { 'name': "待付款", 'tabId': 1, 'isNoMore': false, 'isFooter': false, 'isError': false, 'isNoData': false, 'page': 1, 'total': 0, 'first': true },
    { 'name': "已付款", 'tabId': 2, 'isNoMore': false, 'isFooter': false, 'isError': false, 'isNoData': false, 'page': 1, 'total': 0, 'first': true },
    { 'name': "已完成", 'tabId': 4, 'isNoMore': false, 'isFooter': false, 'isError': false, 'isNoData': false, 'page': 1, 'total': 0, 'first': true },
    { 'name': "退款/售后", 'tabId': 3, 'isNoMore': false, 'isFooter': false, 'isError': false, 'isNoData': false, 'page': 1, 'total': 0, 'first': true }
  ]
  public selectTab = 0;
  public page = 1;
  public isNoOrder = false;
  public isNoMore = false;
  public showFooter = false;
  public isShowLoading = false;
  public total = 0;
  public isDialog = false;
  public orderid;
  public confirmType = -1;
  public dialogMessage = '';
  public isLogin;
  public iswechat ;
  public logid;
  public shopid = 0 ;
  constructor(public router: Router, public nativeService: NativeService, public utils: Utils, public http: HttpService,public routerInfo:ActivatedRoute) { }
  backToPage() {
    this.nativeService.backToPage();
  }
  ngOnInit() {
    this.routerInfo.queryParams.subscribe(queryParams => {
      this.iswechat = queryParams.iswechat == undefined ? 0 : parseInt(queryParams.iswechat);
      this.logid = queryParams.logid ;
      var shopid =  queryParams.shopid == undefined ? 0 : queryParams.shopid;
      if (shopid != 0)this.utils.setLocalStorageItem('shopid',shopid);
      // this.shopid = this.utils.getLocalStorageItem('shopid');
    });
    var isLogin = this.utils.getLocalStorageItem("isLogin");
    if (isLogin == undefined || isLogin == null || isLogin == '') {
      this.isLogin = false;
    } else {
      this.isLogin = isLogin;
    }
    if (!this.isLogin) {
      this.goToLogin();
    } else {
      if (this.iswechat == 1) {
        this.wechatLog();
        // this.utils.setLocalStorageItem('shopid',this.shopid)
      } else {
        // this.shopid = this.utils.getLocalStorageItem('shopid');
      }
      this.getOrderList(this.page, this.selectTab);
    }
  }
  // 微信消息
  public wechatLog() {
    let params = {
      'openalias': 'wap.ticket.Ticketmessage.upWxMsgStatus',
      'id':this.logid ,
      'plat': 'plat_wap',
      'openno': '1',
    }
    this.http.request({
      'method': 'GET',
      'url': 'api/index',
      'data': params
    }).then(result => {
      this.isShowLoading = false;
      this.nativeService.hideLoading();
      if (result.code == 100 && result.data) {
        // console.log(JSON.stringify(result));
        // this.nativeService.showSuccessAlert("微信消息");
      } else {
        // this.wechatLog()
        // this.nativeService.showSuccessAlert("微信消息err");
      }
    })
  }
  // 
  public goToLogin() {
    this.utils.setLocalStorageItem('isWechatAuth', false);
    this.utils.setLocalStorageItem('isWechatAuthGetKey', false);
    this.router.navigate(['login']);
  }
  // 选中的条目
  public potFor(id) {
    if (this.isShowLoading) {
      return;
    }
    this.selectTab = id;
    // if (this.selectTab == 2 || this.selectTab == 3) {
    //   this.isNoOrder = true;
    // } else {
    //   this.isNoOrder = false;
    // }

    this.checkedRequest(this.selectTab);
  }

  public checkedRequest(selectTab) {
    this.isNoMore = false;
    this.isNoOrder = false;
    switch (selectTab) {
      case 0:
        if (this.tabArr[0].first) {
          this.getOrderList(this.tabArr[0].page, selectTab);
        } else {
          this.isNoOrder = this.tabArr[0].isNoData;
          this.isNoMore = this.tabArr[0].isNoMore;
          this.showFooter = this.tabArr[0].isFooter;
        }
        break;
      case 1:
        if (this.tabArr[1].first) {
          this.getOrderList(this.tabArr[1].page, selectTab);
        } else {
          this.isNoOrder = this.tabArr[1].isNoData;
          this.isNoMore = this.tabArr[1].isNoMore;
          this.showFooter = this.tabArr[1].isFooter;
        }
        break;
      case 2:
        if (this.tabArr[2].first) {
          this.getOrderList(this.tabArr[2].page, selectTab);
        } else {
          this.isNoOrder = this.tabArr[2].isNoData;
          this.isNoMore = this.tabArr[2].isNoMore;
          this.showFooter = this.tabArr[2].isFooter;
        }
        break;
      case 3:
        if (this.tabArr[4].first) {
          this.getOrderList(this.tabArr[4].page, selectTab);
        } else {
          this.isNoOrder = this.tabArr[4].isNoData;
          this.isNoMore = this.tabArr[4].isNoMore;
          this.showFooter = this.tabArr[4].isFooter;
        }
        break;
      case 4:
        if (this.tabArr[3].first) {
          this.getOrderList(this.tabArr[3].page, selectTab);
        } else {
          this.isNoOrder = this.tabArr[3].isNoData;
          this.isNoMore = this.tabArr[3].isNoMore;
          this.showFooter = this.tabArr[3].isFooter;
        }
        break;
      default:
        break;
    }
  }
  // 取消订单
  public cancelOrder(event, orderid) {
    event.stopPropagation();
    // console.log("取消订单");
    this.dialogMessage = "点击确定，订单被取消！";
    this.isDialog = true;
    this.orderid = orderid;
    this.confirmType = 1;
  }
  // 立即付款
  public payment(event, orderid) {
    event.stopPropagation();
    console.log("立即付款");
    this.orderid = orderid;
    this.router.navigate(['orderPay'], {
      queryParams: {
        'orderid': this.orderid,
        'orderType': 0,
        'page': -1
      }
    });
  }
  // 查看物流
  public checkLogistics(event, orderid) {
    event.stopPropagation();
    // console.log("查看物流");
    this.router.navigate(['logistics-details'], {
      queryParams: {
        'orderid': orderid
      }
    })
  }
  // 确认收货
  public confirmReceipt(event, orderid) {
    event.stopPropagation();
    // console.log("确认收货");
    this.dialogMessage = "点击确认收货？";
    this.isDialog = true;
    this.orderid = orderid;
    this.confirmType = 2;
  }

  public onLoadMore() {
    // console.log("加载更多...");
    if (this.isShowLoading || this.showFooter || this.isNoMore || this.isNoOrder) {
      return;
    }
    var page_;
    switch (this.selectTab) {
      case 0:
        page_ = this.tabArr[0].page;
        break;
      case 1:
        page_ = this.tabArr[1].page;
        break;
      case 2:
        page_ = this.tabArr[2].page;
        break;
      case 3:
        page_ = this.tabArr[4].page;
        break;
      case 4:
        page_ = this.tabArr[3].page;
        break;
      default:
        break;
    }
    this.showFooter = true;
    this.getOrderList(page_, this.selectTab);
    // setTimeout(, 2000);
    // setTimeout(this.getOrderList(1, 1), 1000);
  }
  public onRefresh() {
    console.log("下拉刷新...");
  }

  /**
   * @param page 页码
   * @param type 类型
   */
  public getOrderList(page, type) {
    let this_ = this;
    if (!this.showFooter) {
      this.isShowLoading = true;
      this.nativeService.showLoading();
    }
    let params = {
      'status': type,
      'page': page,
      'limit': 20,
      'openalias': 'wap.order.ordermalllist.mallOrderList',
      'plat': 'plat_wap',
      'openno': 1,
      'userid': this.utils.getLocalStorageItem('user_id'),
      'user_token': this.utils.getLocalStorageItem('user_token'),
      'shopid': this.shopid,
    }
    this.http.request({
      'method': 'GET',
      'url': 'api/index',
      'data': params
    }).then(result => {
      this.isShowLoading = false;
      this.nativeService.hideLoading();
      if (result.code == 100 && result.data) {
        // console.log(JSON.stringify(result.data));
        this_.examineData(page, type, result.data);
      } else {
        if(result.msg=="登录已过期,请重新登录"||result.msg=="请登录"){
          this.utils.setLocalStorageItem("isLogin",false);
          this.isLogin = false;
          this.goToLogin();
        }
        this.nativeService.showErrorAlert(result.msg);
      }
    })
  }

  public allArr = [];
  public obligationArr = [];
  public paidArr = [];
  public notArr = [];
  public doneArr = [];
  public examineData(page, type, data) {
    this.isNoMore = false;
    this.showFooter = false;
    switch (type) {
      case 0:
        this.tabArr[0].total = data.total;
        this.total = data.total;
        if (this.tabArr[0].total == 0) {
          this.tabArr[0].isNoData = true;
        }
        this.isNoOrder = this.tabArr[0].isNoData;
        this.tabArr[0].first = false;

        if (page == 1) {
          this.allArr = data.list;
          console.log("page:" + page);
        } else {
          this.allArr = this.allArr.concat(data.list);
          console.log("-----page:" + page);
        }
        if (this.tabArr[0].total != 0 && this.allArr.length >= this.tabArr[0].total) {
          this.tabArr[0].isNoMore = true;
          this.isNoMore = true;
        }
        this.tabArr[0].page++;
        console.log("length:" + this.allArr.length + "-----page:" + this.tabArr[0].page);
        break;
      case 1:
        this.tabArr[1].total = data.total;
        this.total = data.total;
        if (this.tabArr[1].total == 0) {
          this.tabArr[1].isNoData = true;
        }
        this.isNoOrder = this.tabArr[1].isNoData;
        this.tabArr[1].first = false;
        if (page == 1) {
          this.obligationArr = data.list;
        } else {
          this.obligationArr = this.obligationArr.concat(data.list);
        }
        if (this.tabArr[1].total != 0 && this.obligationArr.length >= this.tabArr[1].total) {
          this.tabArr[1].isNoMore = true;
          this.isNoMore = true;
        }
        this.tabArr[1].page++;
        break;
      case 2:
        this.tabArr[2].total = data.total;
        this.total = data.total;
        if (this.tabArr[2].total == 0) {
          this.tabArr[2].isNoData = true;
        }
        this.isNoOrder = this.tabArr[2].isNoData;
        this.tabArr[2].first = false;
        if (page == 1) {
          this.paidArr = data.list;
        } else {
          this.paidArr = this.paidArr.concat(data.list);
        }
        if (this.tabArr[2].total != 0 && this.paidArr.length >= this.tabArr[2].total) {
          this.tabArr[2].isNoMore = true;
          this.isNoMore = true;
        }
        this.tabArr[2].page++;
        break;
      case 3:
        this.tabArr[4].total = data.total;
        this.total = data.total;
        if (this.tabArr[4].total == 0) {
          this.tabArr[4].isNoData = true;
        }
        this.isNoOrder = this.tabArr[4].isNoData;
        this.tabArr[4].first = false;
        if (page == 1) {
          this.notArr = data.list;
        } else {
          this.notArr = this.notArr.concat(data.list);
        }
        if (this.tabArr[4].total != 0 && this.notArr.length >= this.tabArr[4].total) {
          this.tabArr[4].isNoMore = true;
          this.isNoMore = true;
        }
        this.tabArr[4].page++;
        break;
      case 4:
        this.tabArr[3].total = data.total;
        this.total = data.total;
        if (this.tabArr[3].total == 0) {
          this.tabArr[3].isNoData = true;
        }
        this.isNoOrder = this.tabArr[3].isNoData;
        this.tabArr[3].first = false;
        if (page == 1) {
          this.doneArr = data.list;
        } else {
          this.doneArr = this.doneArr.concat(data.list);
        }
        if (this.tabArr[3].total != 0 && this.doneArr.length >= this.tabArr[3].total) {
          this.tabArr[3].isNoMore = true;
          this.isNoMore = true;
        }
        this.tabArr[3].page++;
        break;
      default:
        break;
    }
  }

  public goDetails(orderid) {
    this.router.navigate(['mall-order-details'], {
      queryParams: {
        'orderid': orderid
      }
    })
  }

  public cancel() {
    this.isDialog = false;
  }
  public confirm() {
    this.isDialog = false;
    if (this.confirmType == 1) {
      this.cancelOrder_();
      console.log("取消");
    }

    if (this.confirmType == 2) {
      this.confirmReceipt_();
      console.log("确认");
    }
  }
  public confirmReceipt_() {
    this.isShowLoading = true;
    this.nativeService.showLoading();
    let params = {
      'orderid': this.orderid,
      'openalias': 'wap.order.ordermall.confirm',
      'plat': 'plat_wap',
      'openno': 1,
      'userid': this.utils.getLocalStorageItem('user_id'),
      'user_token': this.utils.getLocalStorageItem('user_token'),
    }
    this.http.request({
      'method': 'GET',
      'url': 'api/index',
      'data': params
    }).then(result => {
      this.isShowLoading = false;
      this.nativeService.hideLoading();
      if (result.code == 100 && result.data) {
        console.log(JSON.stringify(result.data));
        this.nativeService.showSuccessAlert("确认收货成功");
        for (var i = 0; i < this.tabArr.length; i++) {
          if (this.tabArr[i].tabId == this.selectTab) {
            this.tabArr[i].page = 1;
          } else {
            this.tabArr[i].page = 1;
            this.tabArr[i].first = true;
          }
        }
        this.getOrderList(1, this.selectTab);
      } else {
        this.nativeService.showErrorAlert(result.msg);
      }
    })
  }
  public cancelOrder_() {
    this.isShowLoading = true;
    this.nativeService.showLoading();
    let params = {
      'orderid': this.orderid,
      'openalias': 'wap.order.ordermall.cancelOrder',
      'plat': 'plat_wap',
      'openno': 1,
      'userid': this.utils.getLocalStorageItem('user_id'),
      'user_token': this.utils.getLocalStorageItem('user_token'),
    }
    this.http.request({
      'method': 'POST',
      'url': 'api/index',
      'data': params
    }).then(result => {
      // this.isShowLoading = false;
      if (result.code == 100 && result.data) {
        console.log(JSON.stringify(result.data));
        this.nativeService.showSuccessAlert("取消订单成功");
        for (var i = 0; i < this.tabArr.length; i++) {
          if (this.tabArr[i].tabId == this.selectTab) {
            this.tabArr[i].page = 1;
          } else {
            this.tabArr[i].page = 1;
            this.tabArr[i].first = true;
          }
        }
        this.getOrderList(1, this.selectTab);
      } else {
        this.isShowLoading = false;
        this.nativeService.hideLoading();
        this.nativeService.showErrorAlert(result.msg);
      }
    })
  }
}
